import {
  DevtoolsFormatter,
  listStyle,
  reference,
  renderCollectionHeader,
} from "./DevtoolsFormatters";
import { HashMap } from "./HashMap";

export const HashMapFormatter: DevtoolsFormatter = {
  header: (o: any) => {
    if (!(o instanceof HashMap)) {
      return null;
    }
    return renderCollectionHeader(o.size(), "HashMap");
  },

  hasBody: (o: any) => {
    if (!(o instanceof HashMap)) {
      return false;
    }
    return o.size() !== 0;
  },

  body: (o: any) => {
    if (!(o instanceof HashMap)) {
      return;
    }

    const keys = [...o.keys()];

    if (typeof keys[0] === "number") {
      keys.sort((a, b) => a - b);
    } else if (typeof keys[0] === "string") {
      keys.sort();
    }

    const children: any[] = [];
    for (const key of keys) {
      children.push(["li", {}, reference(key), " => ", reference(o.get(key))]);
    }
    return ["ol", listStyle, ...children];
  },
};
